export class GridItem {
  constructor(
    {
      isResizable = true,
      isDraggable = false,
      isPinnable = true,
      dragAllowFrom = '.box-header',
      minimized = false,
      selected = false,
      x = 0,
      y = 0,
      w = 30,
      h = 30,
      i = 'Grid Item',
      position = 'absolute',
      zIndex = 1,
      transform = '',
      oldTransform = '',
      pinnedCoords = { x: 0, y: 0 },
      isPinned = false,
      isStatic = false,
    }
  ) {
    this.isResizable = isResizable;
    this.isDraggable = isDraggable;
    this.isPinnable = isPinnable;
    this.dragAllowFrom = dragAllowFrom;
    this.minimized = minimized;
    this.selected = selected;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this.i = i;
    this.position = position;
    this.zIndex = zIndex;
    this.transform = transform;
    this.oldTransform = oldTransform;
    this.pinnedCoords = pinnedCoords;
    this.isPinned = isPinned;
    this.isStatic = isStatic;

    this.origH = h || 0;
    this.origW = w || 0;
  }

  get class() {
    return {
      'selected': this.selected,
      'minimized': this.minimized
    };
  }
  get style() {
    return {
      'overflow': this.minimized ? 'hidden' : 'auto',
      'position': this.position,
      'zIndex': this.zIndex,
    };
  }
}

/** getGridItemFromScrollTopGetter Get Grid Item by providing the scollTop. It calculates the scroll position and finds out the appropriate Route Grid Item */
export const createGIFromSTGtr = (gridItems = [['route', 0]]) => (scrollTop = 0) => {
  // console.log(gridItems);
  if (scrollTop <= gridItems[0][1]) {
    return gridItems[0];
  }
  for (let i = gridItems.length - 1; i > 0; i--) {
    if (scrollTop > gridItems[i][1]) {
      return gridItems[i];
    }
    if (scrollTop < gridItems[i][1] && scrollTop >= gridItems[i - 1][1]) {
      return gridItems[i - 1];
    }
  }
}

export const getGITranslateElement = (element) => {
  if (element) {
    if (element.style) {
      return getGITranslate(element.style.transform);
    } else {
      return getGITranslate();
    }
  } else {
    return getGITranslate();
  }
}


/** Get Grid Item Translate Value from the Grid Item Object */
export const getGITranslate = (string = '') => {

  const defaultTranslate = {
    x: NaN,
    y: NaN,
    z: NaN
  };

  const translateRegex = /translate3d\((.*)\)/i;

  const execRG = translateRegex.exec(string);

  if (!(execRG && execRG[1])) {
    return defaultTranslate;
  }

  const splitValues = execRG[1].split(' ');

  const x = parseInt(splitValues[0], 10);

  const y = parseInt(splitValues[1], 10);

  const z = parseInt(splitValues[2], 10);

  return {
    x,
    y,
    z
  };
};
